import React from 'react'
import styles from './StoreLocatorGeoList.module.sass'
import { Button, WContainer, WLink } from '@components/atoms'
import { ArrowLeft } from '@components/icons'
import { ProvinciaNode, RegioneNode } from '@gql/graphql-get'
import useTrans from '@hooks/useTrans'
import { useRouter } from 'next/router'

interface Props {
  title?: string
  items?: RegioneNode[] | ProvinciaNode[]
  className?: string
  showBackCta?: boolean
}
const StoreLocatorGeoList = (props: Props) => {
  const { title = undefined, items = [], className = '', showBackCta = false } = props

  const t = useTrans()

  const router = useRouter()
  const backHref = showBackCta ? `${'/store-locator'}#${'storelocator-geo'}` : undefined
  const mapHref = `${router.asPath.split('#')[0]}#storelocator-head`
  const pendingScrollRef = React.useRef<number | null>(null)
  const handleBackClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (!backHref) return
    event.preventDefault()
    if (typeof window !== 'undefined') {
      pendingScrollRef.current = window.scrollY
    }
    router.push(backHref, undefined, { scroll: false })
  }

  React.useEffect(() => {
    const handleRouteDone = () => {
      const pendingScroll = pendingScrollRef.current
      if (typeof window !== 'undefined' && pendingScroll !== null) {
        pendingScrollRef.current = null
        setTimeout(() => {
          window.scrollTo(0, pendingScroll)
        }, 0)
      }
    }

    router.events.on('routeChangeComplete', handleRouteDone)
    return () => {
      router.events.off('routeChangeComplete', handleRouteDone)
    }
  }, [router.events])

  return items?.length > 0 ? (
    <div id={'storelocator-geo'} className={`${styles.root} ${className}`}>
      <WContainer>
        <div className={styles.layout}>
          {backHref && (
            <Button
              variant="ghost"
              size="sm"
              iconLeft={<ArrowLeft />}
              label={t("Torna all'elenco Regioni")}
              href={backHref}
              onClick={handleBackClick}
              className={styles.backButton}
            />
          )}
          {!!title && <h2 className={styles.title}>{title}</h2>}
          <div className={styles.list}>
            {items.map((x) => (
              <WLink href={x.slug} className={styles.item}>
                {x.nome}
              </WLink>
            ))}
          </div>
          {showBackCta && (
            <Button
              label={t('Vedi rivenditori sulla mappa')}
              variant="secondary"
              href={mapHref}
              className={styles.mapCta}
            />
          )}
        </div>
      </WContainer>
    </div>
  ) : (
    <></>
  )
}

export default StoreLocatorGeoList
